var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAAqCAYAAADFw8lbAAACaklEQVRYR+2XT07CQBTGZwqp6ILUhXGp3ACP4A24gFhJTFBMrCewnMCaiHFVx3gBb2A8gd5A1ppId5pSWudJKlD657UdMcZ2Q2hn3vzyvZnvvaHkjzz0j3CS/wmqabpiWS86ZKlSkY2rK6MvKmPCFG23tc2PD/ve88gmwFHq9SuVpW1RsEJAg5C+iiJhc4NGQYqGzQWaBCkSNjMoFlIUbCbQtJAiYFODRkGWSlLXcTyVH6CN8aknfUmSbkYj93TaorIesFSgcZCmeaE3m53+NChjl7VW60gXAYsGTYIE1cJA4X0UrKKsbxmGbmGKAhpUVQ8NbubH00Eh3aCk/y4KNBqWnHPVtR8FDULGKeqDBJXl+1g8KNTxt7dXxhetl8vEMM2eEVQiTtEJbEdzHKoS4lorK7KKLbHo1GPSgwHFxAkbU4CCj4I9ZVUwOK9QtFBUxF4qTj00OfOm3T7lXc9qlstZXkX39w/rwyHlZdp74I4BxeX7mQHl9Vzl9fwavlJKLUVZq2GbBkwJTdpefP3nyeVQ6jI26SNmQJvNA8YBd/2Ay8tyDVvi5kHpE2O9rSQ4/zt0Z+/v9rP/n3MwPn/v+/90oLygrVZHG428M4hZKpE905xNXxz0QkEBBJoX+E2zZWD8wkGxqQ6OK0CzKhc1r1BUtKJg9rZNHlH2tLPT0SRpbC9j0yd3fHJXlmXUTTEfvH3Gzb7hx3BdenJ7O7nuzBg+WMtg8DLIt6CY2cFiM1frw+7gYpbGRwm74YZ2+L8JGwb5tQ3j7MK2hw3Hcet4LbKPLJelp2p1jUVVNKF3puyYyTML0GSN0o34BH3o4Dq5a3vfAAAAAElFTkSuQmCC",
    x: 0,
    y: 0,
    width: 42,
    height: 42
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadSign);
export default __webpack_public_path__ + "static/media/UploadSign.93f12484e16cbf33e31e04205e6dde98.svg";
export { ForwardRef as ReactComponent };